import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FilePreviewDialogComponent } from '../../file-preview-dialog/file-preview-dialog.component';

interface File {
  link: SafeResourceUrl;
  uploadedAt: Date;
  notes: string;
}

@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.css']
})
export class FileManagerComponent implements OnInit {
  currentPath: string = '';
  viewMode: string = 'grid';
  items: any[] = [];
  filteredItems: any[] = [];
  searchTerm: string = '';

  ngOnInit() {
    this.loadDirectory('');
  }

  constructor(private dialog: MatDialog) {}
  
  loadDirectory(path: string) {
    this.currentPath = path;
    fetch(`https://app.voyjaleas.com/myapp/fileManager/list_files.php?path=${encodeURIComponent(path)}`)
      .then(res => res.json())
      .then(data => {
        this.items = data;
        this.filteredItems = data;
      });
  }

  previewFile(file: any) {
    const url = this.getFileUrl(file.path);
    this.dialog.open(FilePreviewDialogComponent, {
      data: { file, url },
      width: '800px'
    });
  }

  downloadFile(item: any) {
    const url = this.getFileUrl(item.path);
    window.open(url, '_blank');
  }

  get breadcrumbSegments(): { label: string, path: string }[] {
    const segments = this.currentPath.split('/').filter(s => s);
    const paths = [];
    let fullPath = '';
    for (const segment of segments) {
      fullPath += (fullPath ? '/' : '') + segment;
      paths.push({ label: segment, path: fullPath });
    }
    return paths;
  }

  navigateTo(item: any) {
    if (item.isDirectory) {
      this.loadDirectory(item.path);
    } else {
      this.previewFile(item);
      //window.open(`/CUSTOMER_SERVICE/${item.path}`, '_blank');
    }
  }

  goUp() {
    const segments = this.currentPath.split('/').filter(s => s);
    segments.pop();
    this.loadDirectory(segments.join('/'));
  }
  
  goToRoot() {
    this.loadDirectory('');
  }

  changeViewMode(mode: string) {
    this.viewMode = mode;
  }

  searchFiles() {
    const term = this.searchTerm.toLowerCase();
    this.filteredItems = this.items.filter(item => item.name.toLowerCase().includes(term));
  }

  navigateToPath(path: string) {
    this.loadDirectory(path);
  }

  isPreviewable(fileName: string): boolean {
    return /\.(png|jpe?g|gif|pdf|txt|log)$/i.test(fileName);
  }
  
  getFileUrl(filePath: string): string {
    return `/CUSTOMER_SERVICE/${filePath}`; // Adjust path if needed
  }

}